import React from 'react'
import { arrow, noImage,  player } from '../../../../assets'
import { Link } from 'react-router-dom';

const VideoModal = ({fileType,style, children,isOpen,comments,path, onClose}) => {
    if (!isOpen) return null;
  return (
    <div className='flex justify-center z-20 fixed h-full w-full top-0 right-0 items-center'>
        <div className={style ? 'bg-white fixed  z-[45] rounded-[5px] h-full sm:h-[500px] w-full sm:w-[700px]' : 'bg-white fixed  z-[45] rounded-[5px] h-[250px] sm:h-[400px] flex justify-center overflow-hidden items-center  w-full sm:w-[700px]'}>
            <div>{children || (<img src={noImage} alt='no data available' />)}</div>
        </div>
        {
             !comments &&
        <Link to={path} className=" fixed  z-50 rounded-[5px] h-[250px] sm:h-[400px] flex justify-between px-[15px] overflow-hidden items-center  w-full sm:w-[700px]">
           
            <img className='origin-center h-[14px] rotate-[270deg]' src={arrow} alt="" />
        
            { fileType==='video' &&
                <img className='h-[80px]' src={player} alt="" />
            }
            
            <img className='origin-center rotate-90 h-[14px]' src={arrow} alt="" /> 
            
        </Link>}
        <div onClick={onClose} className="bg-gray-modalBackground z-40 fixed top-0 left-0 w-full h-full flex justify-center items-center "></div>
    </div>
  )
}

export default VideoModal